module.exports = __webpack_public_path__ + "static/media/logo-white.cba1f010.png";